import { useTranslation } from 'react-i18next';
import type { OpticalJobStatus } from '@optiflow/types';
import { Badge } from '@/components/ui/Badge';
import { statusTone } from '../tracking/jobs';

/** A job's status in words, with its colour as a second cue and never the only one. */
export function JobStatusBadge({ status }: { status: OpticalJobStatus }) {
  const { t } = useTranslation();
  return <Badge tone={statusTone(status)}>{t(`sales.opticalJobs.status.${status}`)}</Badge>;
}
